import type { Vehicle } from "../providers/vehiclesProvider";
import type { VehicleType } from "../model/VehicleType";
import type { SvgIconProps } from "@mui/material";
import { CarIcon } from "./CarIcon";
import { MotorcycleIcon } from "./MotorcycleIcon";
import { TrailerIcon } from "./TrailerIcon";
import { SimulatorIcon } from "./SimulatorIcon";
import { TruckIcon } from "./TruckIcon";
import { BusIcon } from "./BusIcon";
import { TractorIcon } from "./TractorIcon";
import { assertNever } from "../backoffice.utils";

export function VehicleIcon(props: { vehicle: Vehicle; type?: never } & SvgIconProps): React.ReactElement;
export function VehicleIcon(props: { vehicle?: never; type: VehicleType } & SvgIconProps): React.ReactElement;
export function VehicleIcon(props: { vehicle?: Vehicle; type?: VehicleType } & SvgIconProps) {
  const { vehicle, type, ...svgIconProps } = props;
  const type_ = vehicle?.type ?? type!;
  switch (type_) {
    case "car":
      return <CarIcon {...svgIconProps} />;
    case "motorcycle":
      return <MotorcycleIcon {...svgIconProps} />;
    case "trailer":
      return <TrailerIcon {...svgIconProps} />;
    case "simulator":
      return <SimulatorIcon {...svgIconProps} />;
    case "truck":
      return <TruckIcon {...svgIconProps} />;
    case "bus":
      return <BusIcon {...svgIconProps} />;
    case "tractor":
      return <TractorIcon {...svgIconProps} />;
    default:
      assertNever(type_);
  }
}
